var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialOrnament(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 27,
    viewBox: "0 0 91 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.388672 0C1.38258 5.38955 5.30605 6.50607 10.046 7.64345C14.5356 8.72084 13.7373 9.37301 17.4443 13.7817C25.4686 23.3295 36.9286 26.7547 45.4407 26.3373C33.9807 25.8886 22.5573 18.4825 17.2199 8.06084C15.4017 4.50781 15.1564 3.8739 11.1573 3.33651C5.10257 2.5226 1.7791 1.30695 0.388672 0Z",
    fill: "url(#paint0_linear_318_4836)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4249 5.30206C6.38404 4.37075 2.26753 4.13597 0.417969 0.0585938C1.41188 5.44814 5.33534 6.56466 10.0753 7.70205C14.5649 8.77944 13.7666 9.43161 17.4736 13.8403C25.4979 23.3881 36.9578 26.8133 45.47 26.3959C38.1526 26.1507 32.7892 24.5411 26.5883 20.3933C22.7066 17.7977 19.4014 14.5081 16.8683 10.3864C16.2866 9.44204 15.7336 8.47683 15.097 7.57161C13.9075 5.87858 12.3136 5.73771 10.4223 5.30206H10.4249Z",
    fill: "url(#paint1_linear_318_4836)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29068 8.79393C6.32112 8.46263 3.42548 7.74002 2.09766 5.98438C2.71592 9.19567 4.61243 11.5461 8.0872 12.0574C10.8889 12.4696 14.0585 12.1826 15.8115 13.8678C13.6802 10.2548 12.2298 9.45915 8.29068 8.79393Z",
    fill: "url(#paint2_linear_318_4836)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.222 14.1399C10.9133 13.8372 6.76552 14.2651 4.94727 12.332C5.99335 16.0077 8.67247 17.1085 12.1759 17.1868C14.6307 17.2416 18.4994 17.912 20.5811 19.4981C17.6098 16.6651 16.9942 14.6329 13.222 14.1399Z",
    fill: "#B26316"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94727 12.332C6.23596 14.419 7.84813 15.1546 10.1986 15.4181C16.0446 16.0703 16.2481 15.5798 20.5811 19.4981C17.6098 16.6651 16.9942 14.6329 13.222 14.1399C10.9133 13.8372 6.76552 14.2651 4.94727 12.332Z",
    fill: "url(#paint3_linear_318_4836)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1986 15.4181C7.84813 15.1546 6.23596 14.419 4.94727 12.332C5.99335 16.0077 8.67247 17.1085 12.1759 17.1868C12.8777 17.2024 13.6968 17.2677 14.5577 17.3929C16.6994 17.7007 19.0968 18.3659 20.5837 19.4981C17.2081 16.4459 16.3394 16.0703 13.3551 15.7442C12.5098 15.6529 11.4925 15.5642 10.2012 15.4181H10.1986Z",
    fill: "url(#paint4_linear_318_4836)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09375 5.98438C3.2494 8.6035 5.1407 9.7748 7.92156 10.4061C11.3181 11.1783 13.1363 10.6852 15.8102 13.8678C13.6789 10.2548 12.2285 9.45915 8.28938 8.79393C6.31982 8.46263 3.42418 7.74002 2.09636 5.98438H2.09375Z",
    fill: "url(#paint5_linear_318_4836)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.332031 0.0585938C1.74333 3.16815 4.47202 4.04206 7.48244 4.69684C5.8181 4.05771 4.6155 3.10293 4.06245 1.94467C2.24681 1.36555 1.03899 0.723809 0.332031 0.0585938Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11722 7.98524C3.91722 7.54176 2.79027 6.90524 2.09375 5.98438C3.2494 8.6035 5.1407 9.7748 7.92156 10.4061C7.96851 10.4165 8.01286 10.427 8.05721 10.4374C6.62243 9.90262 5.74591 9.13306 5.11461 7.98785L5.11722 7.98524Z",
    fill: "url(#paint6_radial_318_4836)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80117 13.6833C6.66639 13.4616 5.63857 13.0677 4.94727 12.332C6.23596 14.419 7.84812 15.1546 10.1986 15.4181C11.0568 15.5146 11.7925 15.5851 12.4394 15.6503C10.3655 15.2877 9.07682 14.9459 7.80117 13.6833Z",
    fill: "url(#paint7_radial_318_4836)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9747 3.6977C13.7112 4.12031 14.653 4.45161 15.5295 5.80552C17.0973 8.22116 19.2599 13.0264 23.8773 16.9498C21.1799 14.3907 18.8999 11.409 17.2199 8.12986C15.4017 4.57683 15.1564 3.94292 11.1573 3.40553C5.10257 2.58901 1.7791 1.37597 0.388672 0.0664062C2.88779 2.81857 7.62517 3.18118 10.9747 3.6977Z",
    fill: "url(#paint8_linear_318_4836)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5028 20.3945C21.468 17.3893 19.0315 14.238 15.8332 9.07537C14.581 7.05364 13.4097 6.23451 12.1393 5.79625C9.82802 4.99799 7.23499 5.0006 4.62891 3.90234C7.32629 4.82321 10.0524 4.74495 12.2098 5.47799C13.9002 6.0519 14.7871 6.81103 16.0993 8.86407C19.7749 14.6188 21.301 16.8545 26.5054 20.3945H26.5028Z",
    fill: "url(#paint9_linear_318_4836)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58984 8.2487C6.39157 10.6017 8.77852 10.44 11.215 10.9356C13.2029 11.34 15.0968 12.2061 16.842 15.3C15.462 13.2756 14.2072 11.8304 11.155 11.1652C8.60635 10.6122 5.96375 10.7974 3.58984 8.24609V8.2487Z",
    fill: "url(#paint10_linear_318_4836)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43359 14.0664C9.53271 16.2968 13.9884 14.8386 17.3927 16.8316C21.4179 19.1873 23.6848 22.9333 28.8292 25.4377C23.0066 22.9359 21.6214 19.7507 17.4423 17.2099C16.3049 16.5186 15.2666 16.2655 14.3431 16.0803C11.9171 15.5925 8.81011 16.0594 6.4362 14.0664H6.43359Z",
    fill: "url(#paint11_linear_318_4836)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4387 0.0612024C89.4448 5.45075 85.5214 6.56727 80.7814 7.70466C76.2918 8.78204 77.0901 9.43422 73.3831 13.8429C65.3588 23.3907 53.8989 26.8159 45.3867 26.3985C56.8467 25.9498 68.2701 18.5438 73.6075 8.12205C75.4258 4.56901 75.671 3.9351 79.6701 3.39771C85.7275 2.58119 89.0509 1.36815 90.4414 0.0585938L90.4387 0.0612024Z",
    fill: "url(#paint12_linear_318_4836)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4394 0.11589C88.5898 4.19327 84.4733 4.42805 80.4325 5.35935C78.5438 5.795 76.9499 5.93587 75.7577 7.62891C75.1212 8.53673 74.5681 9.49934 73.9864 10.4437C71.4534 14.5654 68.1482 17.855 64.2664 20.4506C58.0656 24.5958 52.7021 26.208 45.3848 26.4532C56.8447 26.0045 68.2682 18.5984 73.6055 8.17673C75.4238 4.6237 75.669 3.98979 79.6681 3.4524C85.7255 2.63588 89.049 1.42284 90.4394 0.113281V0.11589Z",
    fill: "url(#paint13_linear_318_4836)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3732 5.36065C84.4115 4.42674 88.5306 4.19457 90.3801 0.117188C89.3862 5.50674 85.4628 6.62325 80.7228 7.76064C76.2332 8.83803 77.0315 9.4902 73.3246 13.8989C65.3002 23.4467 53.8403 26.8719 45.3281 26.4545C52.6455 26.2093 58.0089 24.5997 64.2098 20.4519C68.0915 17.8563 71.3967 14.5667 73.9298 10.445C74.5115 9.50064 75.0646 8.53542 75.7011 7.63021C76.8906 5.93717 78.4845 5.7963 80.3758 5.36065H80.3732Z",
    fill: "url(#paint14_linear_318_4836)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4805 8.79393C84.45 8.46263 87.3457 7.74002 88.6735 5.98438C88.0552 9.19567 86.1587 11.5461 82.684 12.0574C79.8822 12.4696 76.7127 12.1826 74.957 13.8678C77.0883 10.2548 78.5388 9.45915 82.4779 8.79393H82.4805Z",
    fill: "url(#paint15_linear_318_4836)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5505 14.1399C79.8592 13.8372 84.007 14.2651 85.8253 12.332C84.7792 16.0077 82.1001 17.1085 78.5966 17.1868C76.1418 17.2416 72.2731 17.912 70.1914 19.4981C73.1627 16.6651 73.7783 14.6329 77.5505 14.1399Z",
    fill: "#B26316"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8253 12.332C84.5366 14.419 82.9244 15.1546 80.574 15.4181C74.7279 16.0703 74.5244 15.5798 70.1914 19.4981C73.1627 16.6651 73.7783 14.6329 77.5505 14.1399C79.8592 13.8372 84.007 14.2651 85.8253 12.332Z",
    fill: "url(#paint16_linear_318_4836)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5727 15.4181C82.9231 15.1546 84.5353 14.419 85.824 12.332C84.7779 16.0077 82.0988 17.1085 78.5953 17.1868C77.8936 17.2024 77.0744 17.2677 76.2136 17.3929C74.0718 17.7007 71.6745 18.3659 70.1875 19.4981C73.5631 16.4459 74.4318 16.0703 77.4162 15.7442C78.2614 15.6529 79.2788 15.5642 80.5701 15.4181H80.5727Z",
    fill: "url(#paint17_linear_318_4836)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6774 5.98438C87.5218 8.6035 85.6305 9.7748 82.8496 10.4061C79.4531 11.1783 77.6348 10.6852 74.9609 13.8678C77.0922 10.2548 78.5427 9.45915 82.4818 8.79393C84.4513 8.46263 87.347 7.74002 88.6748 5.98438H88.6774Z",
    fill: "url(#paint18_linear_318_4836)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4375 0.0585938C89.0262 3.16815 86.2975 4.04206 83.2871 4.69684C84.9515 4.05771 86.1541 3.10293 86.7071 1.94467C88.5201 1.36815 89.728 0.726418 90.4349 0.0612024L90.4375 0.0585938Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6548 7.98524C86.8548 7.54176 87.9818 6.90524 88.6783 5.98438C87.5227 8.6035 85.6314 9.7748 82.8505 10.4061C82.8035 10.4165 82.7592 10.427 82.7148 10.4374C84.1496 9.90262 85.0261 9.13306 85.6574 7.98785L85.6548 7.98524Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9703 13.6833C84.1051 13.4616 85.1329 13.0677 85.8242 12.332C84.5355 14.419 82.9233 15.1546 80.5729 15.4181C79.7146 15.5146 78.979 15.5851 78.332 15.6503C80.4059 15.2877 81.6946 14.9459 82.9703 13.6833Z",
    fill: "url(#paint19_radial_318_4836)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7951 3.6977C77.0586 4.12031 76.1169 4.45161 75.2404 5.80552C73.6726 8.22116 71.51 13.0264 66.8926 16.9498C69.59 14.3907 71.87 11.409 73.55 8.12986C75.3682 4.57683 75.6134 3.94292 79.6125 3.40553C85.6699 2.58901 88.9934 1.37597 90.3838 0.0664062C87.8847 2.81857 83.1473 3.18118 79.7978 3.6977H79.7951Z",
    fill: "url(#paint20_linear_318_4836)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2663 20.3945C69.301 17.3893 71.7376 14.238 74.9358 9.07537C76.188 7.05364 77.3593 6.23451 78.6297 5.79625C80.941 4.99799 83.534 5.0006 86.1401 3.90234C83.4427 4.82321 80.7167 4.74495 78.5593 5.47799C76.8688 6.0519 75.9819 6.81103 74.6697 8.86407C70.9941 14.6188 69.468 16.8545 64.2637 20.3945H64.2663Z",
    fill: "url(#paint21_linear_318_4836)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1818 8.2487C84.3801 10.6017 81.9931 10.44 79.5566 10.9356C77.5688 11.34 75.6749 12.2061 73.9297 15.3C75.3097 13.2756 76.5645 11.8304 79.6166 11.1652C82.1653 10.6122 84.8079 10.7974 87.1818 8.24609V8.2487Z",
    fill: "url(#paint22_linear_318_4836)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.337 14.0664C81.2379 16.2968 76.7822 14.8386 73.3779 16.8316C69.3527 19.1873 67.0857 22.9333 61.9414 25.4377C67.764 22.9359 69.1492 19.7507 73.3283 17.2099C74.4657 16.5186 75.504 16.2655 76.4274 16.0803C78.8535 15.5925 81.9605 16.0594 84.3344 14.0664H84.337Z",
    fill: "url(#paint23_linear_318_4836)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_4836",
    x1: 0.388672,
    y1: 13.1869,
    x2: 45.4433,
    y2: 13.1869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_4836",
    x1: 0.417969,
    y1: 13.2455,
    x2: 45.4726,
    y2: 13.2455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_4836",
    x1: 2.09505,
    y1: 9.92871,
    x2: 15.8115,
    y2: 9.92871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_4836",
    x1: 4.94727,
    y1: 15.9164,
    x2: 20.5811,
    y2: 15.9164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_4836",
    x1: 4.94727,
    y1: 15.9164,
    x2: 20.5811,
    y2: 15.9164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_4836",
    x1: 2.09375,
    y1: 9.9261,
    x2: 15.8102,
    y2: 9.9261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_318_4836",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.07548 8.20959) scale(2.63217)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4B4432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#827656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AE9F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D1BE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EAD59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F9E3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_318_4836",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4699 10.6755) scale(7.49215 7.49215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4B4432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#827656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AE9F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D1BE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EAD59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F9E3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_4836",
    x1: 0.388672,
    y1: 8.50812,
    x2: 23.8799,
    y2: 8.50812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_4836",
    x1: 4.62891,
    y1: 12.1484,
    x2: 26.5028,
    y2: 12.1484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_4836",
    x1: 3.58984,
    y1: 11.7756,
    x2: 16.842,
    y2: 11.7756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_4836",
    x1: 6.43359,
    y1: 19.7507,
    x2: 28.8292,
    y2: 19.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_318_4836",
    x1: 45.3841,
    y1: 13.2481,
    x2: 90.4387,
    y2: 13.2481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_318_4836",
    x1: 90.4394,
    y1: 13.2872,
    x2: 45.3848,
    y2: 13.2872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_318_4836",
    x1: 90.3801,
    y1: 13.3015,
    x2: 45.3255,
    y2: 13.3015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_318_4836",
    x1: 74.9596,
    y1: 9.92871,
    x2: 88.6761,
    y2: 9.92871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_318_4836",
    x1: 85.8253,
    y1: 15.9164,
    x2: 70.1914,
    y2: 15.9164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_318_4836",
    x1: 85.824,
    y1: 15.9164,
    x2: 70.1901,
    y2: 15.9164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_318_4836",
    x1: 88.6774,
    y1: 9.9261,
    x2: 74.9609,
    y2: 9.9261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_318_4836",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.3016 10.6755) rotate(180) scale(7.49215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4B4432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#827656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AE9F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D1BE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EAD59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F9E3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_318_4836",
    x1: 72.0447,
    y1: 19.9237,
    x2: 85.2264,
    y2: -2.9075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_318_4836",
    x1: 68.8993,
    y1: 23.0684,
    x2: 81.5097,
    y2: 1.22844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_318_4836",
    x1: 87.1818,
    y1: 11.7756,
    x2: 73.9297,
    y2: 11.7756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_318_4836",
    x1: 84.337,
    y1: 19.7507,
    x2: 61.9414,
    y2: 19.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialOrnament);
export default __webpack_public_path__ + "static/media/social-ornament.2101f9eba9108f4da3276b64fccd9745.svg";
export { ForwardRef as ReactComponent };